module.exports = __webpack_public_path__ + "img/icon-group.2459ab6b.svg";